// MARK: used in v2
// rework this to better support setting colours out of tailwind config,
// ie with 'currentColor'

import React from "react"

type Props = {
  color?: string
  size?: "small" | "normal" | "large"
  className?: string
}

const Loader = ({ color = "#222222", size = "normal", className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      width={size === "small" ? 12 : size === "large" ? 40 : 20}
      height={size === "small" ? 12 : size === "large" ? 40 : 20}
      className={className}
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke={color}
        strokeWidth="10"
        r="35"
        strokeDasharray="164.93361431346415 56.97787143782138"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        ></animateTransform>
      </circle>
    </svg>
  )
}

export default Loader
